import { createGlobalStyle } from 'styled-components'
import i18n from 'live/services/i18n'
export const GlobalStyles = createGlobalStyle`
        .live-app.quality-monitoring {
            height: 100%;
            width: 100%;
            .app-footer {
                display: none;
            }
            
        }
        .stoppedLine-confirmation-modal, .addNewFactory-confirmation-modal, .deviation-confirmation-modal{
            .btn-notAllowed{
                background: #BAC0CB;
                cursor: not-allowed;
                border-color: transparent;
                position: relative;
                &:hover{
                    &::after{
                        content: "${i18n('Please fill required fields')}";
                        font-weight: 600;
                        padding: 3px;
                        background: red;
                        font-size: 12px;
                        position: absolute;
                        top: -5px;
                        left: 50%;
                        transform: translate(-50%, -100% );
                        border-radius: 4px;
                    }
                }
            }
        }

        .deviation-confirmation-modal{
            .modal-body{
                padding: 0;
            }
            .btn-notAllowed{
                &:hover{
                    &::after{
                        content: "";
                        display: none;
                    }
                }
            }
        }
    `
